<script setup>

import useToast from "@/composables/useToast";

const { toasts, dismissToast } = useToast();

</script>

<template>
  <div class="toast-container position-fixed top-0 end-0 p-3 toast-host">
    <TransitionGroup name="toast-fade">

      <div
          v-for="toast in toasts"
          :key="toast.id"
          class="toast fade show border-0"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
      >

        <div class="toast-header border-0" :class="`text-bg-${toast.variant}`">
          <strong class="me-auto">{{ toast.title }}</strong>

          <span v-if="toast.status" class="badge bg-light text-dark ms-2">
            {{ toast.status }}
          </span>

          <button
              type="button"
              class="btn-close btn-close-white ms-2"
              aria-label="Close"
              @click="dismissToast(toast.id)"
          ></button>
        </div>

        <div v-if="toast.message || toast.details.length" class="toast-body">
          <div v-if="toast.message">{{ toast.message }}</div>

          <ul v-if="toast.details.length" class="mb-0 mt-1 ps-3">
            <li v-for="(detail, index) in toast.details" :key="index">
              {{ detail }}
            </li>
          </ul>
        </div>

      </div>

    </TransitionGroup>
  </div>
</template>

<style scoped>
.toast-host {
  z-index: 2000;
}

.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.toast-fade-enter-from,
.toast-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>
